<script>
import useServiceType from '../../../../../Composables/Service/useServiceType.ts'
import mixinComponent from '../../../Mixins/mixinComponent'
import { globalVariablesMixin } from '../../../Mixins/global'
import ModalError from '../../UI/Modal/ModalError.vue'
import BlockContent from '../../UI/Content/BlockContent.vue'
import EntityLink from '../../UI/Button/EntityLink.vue'
import ButtonAll from '../../UI/Button/ButtonAll.vue'
import DocumentList from '../../Document/DocumentList.vue'
import ServiceSelector from '../../Service/ServiceSelector.vue'
import ServiceFormModal from '../../Service/ServiceFormModal.vue'
import SimulationRefinancerModal from './SimulationRefinancerModal.vue'
import SimulationApplicationFeeModal from './SimulationApplicationFeeModal.vue'
import SimulationProposalModal from './SimulationProposalModal.vue'
import SimulationAcceptedModal from './SimulationAcceptedModal.vue'
import SimulationExistingDecisionModal from './SimulationExistingDecisionModal.vue'
import SimulationNewDemandModal from './SimulationNewDemandModal.vue'
import RentCalculatorModal from '../../Calculator/RentCalculatorModal.vue'
import AmountCalculatorModal from '../../Calculator/AmountCalculatorModal.vue'

export default {
  components: {
    AmountCalculatorModal,
    RentCalculatorModal,
    SimulationNewDemandModal,
    SimulationExistingDecisionModal,
    SimulationAcceptedModal,
    SimulationProposalModal,
    BlockContent,
    ButtonAll,
    DocumentList,
    EntityLink,
    ModalError,
    ServiceFormModal,
    ServiceSelector,
    SimulationApplicationFeeModal,
    SimulationRefinancerModal,
  },
  mixins: [mixinComponent, globalVariablesMixin],

  emits: ['rent-updated', 'service-updated', 'update-simulation'],

  props: {
    simulation: { type: Object, required: true },
    simulationId: { default: '' },
    def: { type: Object, default: {} },
    theme: { type: String, default: '' },
    showTtc: { type: Boolean, default: true },
    decisions: { type: Array, default: [] },
  },

  data() {
    let selected
    if (this.simulation.finance) {
      selected = this.simulation.finance.rentInfo
    } else {
      selected = ''
    }
    return {
      displayTTC: false,
      displayHT: true,
      rent: null,
      isRentVisible: false,
      isProposalVisible: false,
      isInfoSaisieVisible: false,
      isAcceptedVisible: false,
      isLoadingDeal: false,
      isRequestVisible: false,
      isFeesVisible: false,
      isRefinancerVisible: false,
      selectedRent: selected,
      serviceText: false,
      loadingServices: new Map(),
      selectedService: null,
      selectedServiceType: null,
      errors: [],
      missings: [],
    }
  },

  methods: {
    setEquipment(json) {
      this.getServiceLevel(json)

      if (json.serviceType && json.serviceType.id == 38) {
        this.serviceText = true
      } else {
        this.serviceText = false
      }

      //mettre à jour l'équipement
      this.$root.addValue(this.simulation.equipment, json.equipment)
      const clone = structuredClone(this.simulation.finance.services)
      if (this.simulation.finance.services.length == 0) {
        clone.push(json)
        this.$emit('service-updated', clone)
      } else {
        this.simulation.finance.services = this.simulation.finance.services.map((service, index) => {
          if (service.id == json.id) {
            //mettre à jour le service pour afficher le pack
            return json
          }
          return service
        })
        this.$emit('service-updated', this.simulation.finance.services)
      }
    },
    getServiceLevel(service) {
      for (let i = 0; i < this.simulation.finance.rents.length; i++) {
        this.setValue(this.simulation.finance.rents[i], 'hasServiceLevel', service?.level ?? false)
      }
    },

    afterUpload(document) {
      if (document.documentType.internalName === 'pdf_decision') {
        location.reload()
      }
    },
    setRentWithServices(rent) {
      let rentWithServices = this.simulation.finance.services.reduce(
        (total, service) => {
          if (!service.active) {
            return total
          }
          const amountDurations = service.amountDurations
          const amountDuration = amountDurations.hasOwnProperty(this.selectedRent.duration)
            ? amountDurations[this.selectedRent.duration]
            : amountDurations[0]
          if (this.displayTTC) {
            return total + parseFloat(amountDuration?.amountVat || '0')
          } else {
            return total + parseFloat(amountDuration?.amount || '0')
          }
        },
        parseFloat(this.setMonthlyRent(rent.rent)),
      )

      return this.getRoundFloat(rentWithServices, 1, 100)
    },
    setRents() {
      if (this.simulation.finance) {
        this.setValue(this.simulation.finance, 'rents', Array.from(this.simulation.finance.rents))
      }
    },

    setTable() {
      //si je suis vendeur je vois le 1er bloc quelque soit le statut
      //si je suis loueur je vois le premier bloc que quand je suis dans certains statut,
      //sinon je vois le nouveau bloc
      if (
        !user.isBusinessMan ||
        this.isRequestable ||
        this.simulation.refused ||
        this.simulation.decision == null ||
        this.simulation.status == 'ERROR' ||
        this.simulation.status == 'CANCELED' ||
        conf.theme_dir === 'lbp'
      ) {
        let modalIcon = document.getElementById('modal-info-icon')
        if (
          this.isNotAccepted ||
          this.simulation.refused ||
          this.simulation.decision == null ||
          this.simulation.status === 'ERROR' ||
          this.simulation.status === 'CANCELED'
        ) {
          modalIcon.classList.add('text-center')
          modalIcon.innerHTML = '<i class="fas fa-times text-danger" style="font-size:65px;margin:20px 0;"></i>'
        } else {
          modalIcon.classList.add('swal2-icon-success')
        }
        document.getElementById('modal-info-body').innerHTML =
          `<div class='text-center fs-18 my-3'>${this.getMessage()}</div>\n`
      } else {
        let decisions = this.simulation.decisions
        let study = 0,
          accepted = 0,
          refused = 0
        decisions.map((dec) => {
          if (
            dec.status == 'STUDY' ||
            dec.status == 'TO_BE_COMPLETED' ||
            dec.status == 'REQUESTED' ||
            dec.status == 'DETAILLED_STUDY' ||
            dec.status == 'PREACCEPTED'
          ) {
            study += 1
          } else if (
            dec.status == 'ACCEPTED' ||
            dec.status == 'ACCEPTEDS' ||
            dec.status == 'CHANGED' ||
            dec.status == 'ACCEPTED_FORCED' ||
            dec.status == 'CONDITIONAL' ||
            dec.status == 'EXPIRED'
          ) {
            accepted += 1
          } else if (dec.status == 'REFUSED' || dec.status == 'NOT_ACCEPTED' || dec.status == 'DEFINITIVE_REFUSAL') {
            refused += 1
          }
        })

        if (study == 0) {
          study = '-'
        }
        if (accepted == 0) {
          accepted = '-'
        }
        if (refused == 0) {
          refused = '-'
        }
        document.getElementById('modal-info-body').innerHTML = `<div class="my-3 text-center">
            <h4>${accepted > 0 ? `<i class="fas fa-check text-success"></i>` : `<i class="fas fa-tasks"></i>`} ${this.$t('simulation.result.demandRecap')}</h4>
            </div>\n
            ${accepted > 0 ? `<div class="text-center fs-18 my-4">${this.$t('simulation.status.ACCEPTED.message')}</div>\n` : ''}
            <div class="row d-flex">
              <div class="col col-md-4 flex-fill text-center">
                <div class="badge" style="color:white;background-color:${this.getStatusColor('STUDY')}">${this.$t('simulation.status.STUDY.label')}</div>
                <h4 class="font-weight-bold mt-3">${this.$t('simulation.result.demandResult', { data: study, all: decisions.length })}</h4>
              </div>
              <div class="col col-md-4 flex-fill border-information text-center">
                <div class="badge" style="color:white;background-color:${this.getStatusColor('ACCEPTED')}">${this.$t('simulation.status.ACCEPTED.label')}</div>
                <h4 class="font-weight-bold mt-3">${this.$t('simulation.result.demandResult', { data: accepted, all: decisions.length })}</h4>
              </div>
              <div class="col col-md-4 flex-fill text-center">
                <div class="badge" style="color:white;background-color:${this.getStatusColor('REFUSED')}">${this.$t('simulation.status.REFUSED.label')}</div>
                <h4 class="font-weight-bold mt-3">${this.$t('simulation.result.demandResult', { data: refused, all: decisions.length })}</h4>
              </div>
            </div>`
      }

      $('#modal-info').modal('show')

      let blocProposition = document.getElementById('d_proposition')
      let waiting = document.getElementById('d_waiting')
      if (waiting !== null) {
        waiting.classList.remove('d-none')

        waiting.classList.add('d-none')
      }

      if (blocProposition !== null) {
        blocProposition.classList.remove('d-none')
      }

      $('html, body').animate(
        {
          scrollTop: $('#proposalbox').offset().top - 40,
        },
        2000,
      )
    },

    setTextRentTrim() {
      let text
      if (!this.isMonthly) {
        if (this.simulation.finance && ['AMOUNT', 'RENT'].includes(this.simulation.finance.computeType)) {
          this.displayTTC
            ? (text = this.$t('simulation.result.table.rentTtc.' + this.simulation.finance.period.id))
            : (text = this.$t('simulation.result.table.rentHt.' + this.simulation.finance.period.id))
        } else {
          this.displayTTC
            ? (text = this.$t('simulation.result.table.amountTtc'))
            : (text = this.$t('simulation.result.table.amountHT'))
        }
      }
      return text
    },

    setQuaterlyRent(rent, amount) {
      let value
      if (!this.isMonthly) {
        if (['AMOUNT', 'RENT'].includes(this.simulation.finance.computeType)) {
          this.displayTTC ? (value = this.getRoundFloat(rent, 1.2, 100)) : (value = rent)
        } else {
          this.displayTTC ? (value = this.getRoundFloat(amount, 1.2, 100)) : (value = amount)
        }
      }
      return value
    },

    setTextRent() {
      return this.displayTTC
        ? this.$t('simulation.result.table.monthlyTtc')
        : this.$t('simulation.result.table.monthlyHt')
    },

    setMonthlyRent(rent) {
      return this.displayTTC ? this.getRoundFloat(rent, 1.2, 100) : rent
    },

    createContract() {
      this.postJSON(
        'contracts',
        {
          simulationId: this.simulationId,
          duration: this.selectedRent.duration,
        },
        {},
      ).then(
        (json) => {
          location = '/contrats/contract.php?i=' + json.id + '&p=contract'
        },
        (reason) => {},
      )
    },

    goToService() {
      window.location.href = '/devis/simulation.php?i=' + this.simulationId + '&p=service&index=simulation'
    },
    goToDemand() {
      window.location.href = '/devis/simulation.php?i=' + this.simulationId + '&p=demand&index=simulation'
    },

    /* @deprecated */
    async sendToggle(serviceTypes, serviceType, isActivating) {
      if (!isActivating) {
        await this.disableService(serviceType)
      } else {
        await this.enableService(serviceType)
      }
    },
    async enableService(serviceType) {
      if (serviceType.mandatorySupplier && this.shouldFillServiceSupplier(serviceType)) {
        this.showServiceForm(serviceType)
        return
      }

      this.loadingServices.set(serviceType.id, true)
      const requests = []
      if (serviceType.equipmentExcluded === true) {
        requests.push(this.postJSON(`services`, { financeId: this.simulation.finance.id, serviceType: serviceType.id }))
      } else {
        const equipments = [this.simulation.equipment, ...this.simulation.equipment.equipments]
        equipments
          .filter((equipment) => !equipment.isOutstanding)
          .forEach((equipment) => {
            requests.push(
              this.postJSON(
                `services`,
                { financeId: this.simulation.finance.id, serviceType: serviceType.id, equipment: equipment.id },
                { displayError: false },
              ),
            )
          })
      }

      const responses = await Promise.allSettled(requests)

      const addedServices = responses.filter(({ status }) => status === 'fulfilled').map(({ value }) => value)

      addedServices.forEach((addedService) => {
        const indexToDelete = this.simulation.finance.services.findIndex((service) => service.id === addedService.id)
        if (indexToDelete > -1) {
          this.simulation.finance.services.splice(indexToDelete, 1)
        }
      })
      this.setValue(this.simulation.finance, 'services', this.simulation.finance.services.concat(addedServices))
      this.loadingServices.delete(serviceType.id)

      for (const currentServiceType of this.activeServiceTypes) {
        if (
          currentServiceType.serviceCategory.id === serviceType.serviceCategory.id &&
          currentServiceType.id !== serviceType.id &&
          (currentServiceType.exclusive === true || serviceType.exclusive === true)
        ) {
          this.setValue(currentServiceType, 'active', false)
          await this.disableService(currentServiceType)
        }
      }

      this.errors = responses.filter(({ status }) => status === 'rejected').map(({ reason }) => reason.response.detail)

      await this.$nextTick()
      if (this.errors.length > 0) {
        this.$refs['modalError'].open()
      } else if (this.isServiceTypeEditable(serviceType)) {
        this.showPopupService(serviceType)
      }
    },
    async disableService(serviceType) {
      this.loadingServices.set(serviceType.id, true)
      const requests = this.simulation.finance.services
        .filter((service) => service.serviceType.id === serviceType.id)
        .map((service) =>
          this.deleteJSON(`services/${service.id}`, { financeId: this.simulation.finance.id, id: service.id }),
        )

      try {
        await Promise.all(requests)

        this.setValue(
          this.simulation.finance,
          'services',
          this.simulation.finance.services.filter((service) => service.serviceType.id !== serviceType.id),
        )

        this.setRents()
      } catch (error) {
        alert(error)
      } finally {
        this.loadingServices.delete(serviceType.id)
      }
    },
    setProfitabilityUp: function (rent) {
      this.patchJSON('quotations/' + this.simulationId + '/select', { duration: rent.duration }).then(
        (json) => {
          location.reload()
        },
        (reason) => {
          alert(reason)
        },
      )
    },

    showPopupFees: function () {
      this.isFeesVisible = !this.isFeesVisible
    },

    showPopupDeals: function () {
      if (!this.isClientSirenValid()) {
        return
      }

      this.isLoadingDeal = true
      this.$refs.modalDeals.showModal()
    },

    showPopupRequest: function (value) {
      if (value) this.isRequestVisible = !this.isRequestVisible
    },

    showPopupProposal: function () {
      this.isProposalVisible = !this.isProposalVisible
    },

    showPopupAccepted: function () {
      this.isAcceptedVisible = !this.isAcceptedVisible
    },

    showPopupRefinancer() {
      this.$refs.modalRefinancer.showModal()
    },

    updateSimulation() {
      this.$emit('update-simulation')
    },

    sendRentUp(rent) {
      this.setValue(this, 'rent', rent)
      this.selectedRent = rent
      this.updateSimulation()
    },

    setTTC: function () {
      this.displayTTC = true
      this.setRents()
    },

    setHT: function () {
      this.displayTTC = false
      this.setRents()
    },

    isLoading() {
      this.isLoadingDeal = !this.isLoadingDeal
    },

    sendLevel(obj) {
      let index = this.simulation.finance.rents.findIndex((r) => r.id === obj.rent.id)
      if (index !== -1) {
        this.setValue(this.simulation.finance, 'rentInfo', obj.rent)
      }
    },

    createQuotation() {
      if (!this.isClientSirenValid()) {
        return
      }

      this.postJSON('quotationcreate', { simulationId: this.simulationId, changed: true }, {}).then(
        (json) => {
          location = '/devis/simulation.php?i=' + json.simulationIdCreated + '&p=devis&index=simulation'
        },
        (reason) => {
          alert(reason)
        },
      )
    },

    isClientSirenValid() {
      if (!this.simulation.client.siren) {
        this.$root.jsonStatus = 'info'
        this.$root.jsonStatusText = this.$t('demand.error.missingSiren')
        this.$root.jsonWaitingText = this.$t('demand.error.missingSiren')
        $('#modal-waiting-text').modal({ backdrop: 'static', keyboard: false })
        return false
      }
      return true
    },

    reloadPage() {
      //recharger si besoin
    },

    getStatusColor(status) {
      switch (status) {
        case 'CREATED':
        case 'NONE':
        case 'EXPIRED':
        case 'ALREADY_ASSIGN':
          return 'gray'
        case 'CLIENT_REQUEST':
        case 'STUDY':
        case 'TO_BE_COMPLETED':
        case 'REQUESTED':
        case 'CLIENT_PROPOSAL':
        case 'PREACCEPTED':
          return '#337ab7'
        case 'ACCEPTEDS':
        case 'ACCEPTED':
        case 'CLIENT_ACCEPTED':
        case 'CLIENT_CONTRACT':
          return 'lightgreen'
        case 'CONDITIONAL':
          return 'green'
        case 'NOT_ACCEPTED':
          return '#f39c12'
        case 'DEFINITIVE_REFUSAL':
        case 'REFUSED':
        case 'CLIENT_REFUSED':
          return 'lightcoral'
        case 'ERROR':
          return 'red'
      }
    },

    getMessage() {
      const messageKeys = []
      let hasAdditionalMessage = false
      if (this.simulation.status === 'CLIENT_CONTRACT') {
        messageKeys.push(`simulation.status.CLIENT_CONTRACT.message`)
      } else if (this.simulation.status === 'CLIENT_REQUEST' && this.simulation.refinancerStatus === 'CREATED') {
        messageKeys.push(`simulation.status.CREATED.message`)
      } else if (this.simulation.decision && !this.simulation.decision.isCompatible) {
        messageKeys.push('simulation.status.CHANGED.message')
      } else if (this.simulation.decision?.status && this.simulation.decision.status !== 'REFUSED') {
        messageKeys.push(`simulation.status.${this.simulation.decision.status}.message`)
        if (this.simulation.decision.status === 'CREATED') {
          hasAdditionalMessage = true
        }
      } else if (this.simulation.refused) {
        messageKeys.push(`simulation.status.${this.simulation.status}.message`)
      } else if (this.isNotAccepted) {
        messageKeys.push(`simulation.status.${this.simulation.refinancerStatus}.message`)
      } else if (
        this.simulation.isEligible &&
        this.simulation.decision === null &&
        this.simulation.refinancerStatus === 'CREATED'
      ) {
        messageKeys.push('simulation.decision.noEligible')
      } else if (
        this.hasRole('ROLE_DEALS') &&
        this.simulation.refinancerStatus === 'CREATED' &&
        this.simulation.status !== 'CANCELED'
      ) {
        messageKeys.push(`simulation.status.CREATED.message`)
        hasAdditionalMessage = true
      } else {
        messageKeys.push(`simulation.status.${this.simulation.status}.message`)
        if (this.simulation.status === 'CREATED') {
          hasAdditionalMessage = true
        }
      }

      if (hasAdditionalMessage) {
        if (this.isRequestable && this.hasRole('ROLE_DEALS')) {
          messageKeys.push(`simulation.status.CREATED.dealMessage`)
        } else if (this.canSendRequest) {
          messageKeys.push(`simulation.status.CREATED.finaliseMessage`)
        }
      }

      const messages = messageKeys.map((messageKey) => {
        return this.$root.$t(messageKey, { number: this.simulation.contractNumber })
      })

      return messages.join('</br></br>')
    },

    getTTC(ht) {
      return this.getRoundFloat(ht, 1.2, 100)
    },

    getNumber(value) {
      if (value) {
        value = value.replace(',', '.')
        return parseFloat(value)
      }
      return ''
    },
    statusClass(status) {
      const statusClasses = {
        STUDY: 'text-info',
        CLIENT_REQUEST: 'text-info',
        REQUESTED: 'text-primary',
        ACCEPTED: 'text-success',
        PREACCEPTED: 'text-success',
        TO_BE_COMPLETED: 'text-warning',
        DETAILLED_STUDY: 'text-warning',
        '': 'text-warning',
      }
      return statusClasses[status] || ''
    },
    async onServiceEdit(serviceType) {
      const shouldFillServiceSupplier = this.shouldFillServiceSupplier(serviceType)
      if (!this.isServiceTypeActive(serviceType)) {
        const serviceTypes = this.activeServiceTypes.reduce(
          (serviceTypes, { id }) => Array.of(...serviceTypes, id),
          [serviceType.id],
        )
        await this.sendToggle(serviceTypes, serviceType, true)
        this.setValue(serviceType, 'active', true)
      }

      const existingService = this.getFirstServiceByServiceType(serviceType)
      if (!shouldFillServiceSupplier || existingService !== null) {
        this.showServiceForm(serviceType)
      }
    },
    showServiceForm(serviceType) {
      this.loadingServices.set(serviceType.id, true)
      this.showPopupService(serviceType)
      this.loadingServices.delete(serviceType.id)
    },
    onServiceUpdated(service) {
      const serviceIndex = this.simulation.finance.services.findIndex(({ id }) => id === service.id)

      this.setValue(this.simulation.finance.services, serviceIndex, service)
      this.selectedService = service
    },
    showPopupService(serviceType) {
      this.selectedService = this.getFirstServiceByServiceType(serviceType)
      if (!this.selectedService) {
        this.selectedServiceType = serviceType
      }
    },
    hidePopupService() {
      this.selectedService = null
      this.selectedServiceType = null
    },
    isServiceTypeActive({ id }) {
      return this.activeServiceTypes.some((serviceType) => serviceType.id === id)
    },
    isServiceTypeEditable(serviceType) {
      if (this.simulation.equipment.equipments.length > 0) {
        return false
      }

      const services = this.simulation.finance.services.filter((service) => service.serviceType.id === serviceType.id)
      if (services.length > 1) {
        return false
      }

      return serviceType.editable
    },
    shouldFillServiceSupplier(serviceType) {
      const { shouldFillServiceSupplier } = useServiceType(serviceType)

      return shouldFillServiceSupplier.value
    },
    getFirstServiceByServiceType(serviceType) {
      return this.simulation.finance.services.find((service) => service.serviceType.id === serviceType.id)
    },
    showCalculator(rentId) {
      if (this.simulation?.company?.computeAmountMode) {
        this.$refs[`modal-amount-calculator${rentId}`][0].showForm()
      } else if (this.simulation?.company?.computeRentMode) {
        this.$refs[`modal-rent-calculator${rentId}`][0].showForm()
      }
    },
    isTheme(expectedThemes) {
      return expectedThemes.includes(conf.theme_dir)
    },
    getMissingDocuments() {
      this.getJSON('documents?contextId=' + this.simulationId + '&context=AppBundle\\Entity\\Simulation').then(
        (json) => {
          this.missings = json.missings
        },
      )
    },
    selectRentClasses(rent) {
      return {
        'text-center': true,
        'font-weight-bold': this.selectedRent.duration === rent.duration,
        'text-decoration-through': rent.hasLevel,
      }
    },
  },

  computed: {
    hasServiceLevel() {
      return this.simulation.finance.services?.length > 0
    },
    hasContractCreate() {
      return (
        this.isCreatable &&
        this.simulation?.decision?.isCompatible &&
        !user.isReadOnly &&
        !this.hasRole('ROLE_HIDE_BUTTON_CONTRACT_CREATE')
      )
    },
    display() {
      return this.def.sirenClient !== undefined && this.def.sirenClient.options.display && this.simulation.score >= 0
    },

    displayEdit() {
      return (
        user.isReadOnly === false &&
        this.simulation.decision !== null &&
        this.hasRole('ROLE_RENT_EDIT') === true &&
        this.simulation.status !== 'CANCELED'
      )
    },

    displayAccepted() {
      return (this.isCreatable || this.isCreated) && !this.isTheme(['facilease'])
    },
    showMonthly() {
      return this.isMonthly || this.isTheme(['fiparc', 'synaxel'])
    },
    isMonthly() {
      return this.simulation.finance.period.id === 1
    },
    isQuaterly() {
      return this.simulation.finance.period.id === 2
    },
    isQuaterlyAmountComputeType() {
      return this.simulation.finance.computeType === 'AMOUNT' && !this.isMonthly
    },
    isQuaterlyRentComputeType() {
      return this.simulation.finance.computeType === 'RENT' && this.isQuaterly
    },
    isProposable() {
      if (
        !this.simulation.refused &&
        (this.simulation.status == 'DETAILLED_STUDY' ||
          this.simulation.status == 'STUDY' ||
          this.simulation.status == 'CLIENT_PROPOSAL' ||
          this.simulation.status == 'CREATED' ||
          this.simulation.status == 'CLIENT_REQUEST' ||
          this.simulation.status == 'PREACCEPTED')
      ) {
        return true
      }
      return false
    },

    isRequestable() {
      if (
        (this.simulation.status == 'CLIENT_PROPOSAL' || this.simulation.status == 'CREATED') &&
        this.simulation.refinancerStatus == 'CREATED'
      ) {
        return true
      }
      return false
    },

    isStudyable() {
      if (
        (this.simulation.refinancerStatus == 'REFUSED' ||
          this.simulation.refinancerStatus == 'NOT_ACCEPTED' ||
          this.simulation.refinancerStatus == 'TO_BE_COMPLETED') &&
        this.hasRole('ROLE_DETAILLED_STUDY')
      ) {
        return true
      }
      return false
    },

    isCreatable() {
      if (
        this.simulation.status == 'ACCEPTED' ||
        this.simulation.status == 'CONDITIONAL' ||
        this.simulation.status == 'ACCEPTED_FORCED'
      ) {
        return true
      }
      return false
    },

    isCreated() {
      if (this.simulation.status == 'CLIENT_CONTRACT') {
        return true
      }
      return false
    },

    isNotAccepted() {
      return this.simulation.refinancerStatus === 'NOT_ACCEPTED'
    },

    rents() {
      let financeRents = this.simulation.finance.rents

      if (this.simulation.decision && this.simulation.decision.rent) {
        // Filtrer les éléments de financeRents en fonction de la durée maximale
        const maxDecisionDuration = this.simulation.decision.maxDecisionDuration
        financeRents = financeRents.filter((rent) => rent.duration <= maxDecisionDuration)
      }

      // Disable rent durations for which some service is not available
      const rentDurations = financeRents.map((rent) => rent.duration)
      const unavailableServicesByDuration = this.simulation.finance.services.reduce((obj, service) => {
        if (Array.isArray(service.amountDurations)) {
          return obj
        }
        const serviceDurations = Object.keys(service.amountDurations).map(Number)
        rentDurations.forEach((duration) => {
          if (!serviceDurations.includes(duration)) {
            if (obj[duration] === undefined) {
              obj[duration] = []
            }
            obj[duration].push(service.serviceType.name)
          }
        })
        return obj
      }, {})
      const disabledDurations = Object.keys(unavailableServicesByDuration).map(Number)
      if (disabledDurations.length > 0) {
        financeRents = financeRents.map((rent) => {
          const disabled = disabledDurations.includes(rent.duration)
          return {
            ...rent,
            disabled,
            title: disabled
              ? this.$t('simulation.result.table.noOfferAvailableIn', {
                  services: unavailableServicesByDuration[rent.duration].join(', '),
                })
              : null,
          }
        })
      }

      return financeRents
    },
    activeServiceTypes() {
      return this.def.finance.serviceTypes.options.choices.filter(({ active }) => active)
    },
    hasServices() {
      return this.simulation.finance.services.some(
        (service) => service.active && !service.serviceType.serviceCategory.hidden,
      )
    },
    hasModalRefinancer() {
      return this.hasRole('ROLE_RENT_EDIT') && Object.entries(this.simulation.decisions).length > 0
    },
    canSendRequest() {
      return (
        this.isRequestable &&
        !this.hasRole('ROLE_DETAILLED_STUDY') &&
        !user.isReadOnly &&
        this.hasRole('ROLE_SIMULATION_SEND_REQUEST')
      )
    },
    missingBlockingDocuments() {
      return this.missings.filter(({ isBlocking }) => isBlocking)
    },
  },

  mounted() {
    this.setTable()
    if (this.simulation.finance && this.simulation.finance.services) {
      for (const [index, service] of Object.entries(this.simulation.finance.services)) {
        for (const [key, value] of Object.entries(service.serviceType)) {
          if (key == 'id' && value == 38 && service.active) {
            this.serviceText = true
          }
        }
      }
    }
    this.getMissingDocuments()
  },
}
</script>
<template>
  <div id="proposalbox">
    <div id="d_waiting">
      <p>{{ $t('simulation.result.wait') }}</p>
    </div>

    <div id="d_proposition" class="d-none">
      <BlockContent inner-bloc-class="no-gap" e2e-block="simulationRents">
        <template #header>
          <h4 v-html="$t('simulation.result.title')"></h4>
          <i
            v-if="hasRole('ROLE_DECISION_SHOW')"
            class="fas fa-eye"
            @click="showPopupRefinancer"
            style="cursor: pointer"
            e2e-button="simulationRefinancerDetails"
          ></i>
        </template>
        <template #header-title>
          <p style="font-size: 24px; margin-left: 10px; margin-bottom: 0 !important; line-height: 2">
            {{ $t('simulation.result.proposal') }}
            <b>
              <EntityLink v-if="simulation.client" :entity="simulation.client" e2e-data="simulationClientName" />
            </b>
          </p>
        </template>
        <div class="row">
          <div class="col-xl-2 col-lg-12">
            <ButtonAll
              margin="no"
              v-show="!displayTTC && showTtc"
              type="validation"
              @click="setTTC()"
              label="simulation.result.table.displayTtc"
              e2e-button="simulationTTC"
            />
            <ButtonAll
              margin="no"
              v-show="displayTTC && showTtc"
              type="validation"
              @click="setHT()"
              label="simulation.result.table.displayHt"
              e2e-button="simulationHT"
            />
          </div>
          <div class="col-xl-10 col-lg-12">
            <ServiceSelector
              :def="def"
              :finance="simulation.finance"
              :equipment="simulation.equipment"
              :services="simulation.finance.services"
              :duration="selectedRent.duration"
              :display-ttc="displayTTC"
              :loading="loadingServices"
              :readonly="!hasRole('ROLE_EDIT_SIMULATION_SERVICES')"
              @toggle-sent="sendToggle"
              @services-sent="setEquipment"
              @edit="onServiceEdit"
              @has-service-level="getServiceLevel"
            />
          </div>
        </div>
        <div class="overflow-sizing">
          <table id="mytable" class="table table-striped _table-bordered table-hover fs-16" cellspacing="0">
            <thead>
              <tr>
                <th class="text-center font-weight-bold">{{ $t('simulation.result.table.duration') }}</th>

                <th class="text-center font-weight-bold" v-if="simulation.finance.initialRent > 0">
                  {{ $t('simulation.result.table.initialRent') }}
                </th>

                <th class="text-center font-weight-bold" v-if="isQuaterlyAmountComputeType">{{ setTextRentTrim() }}</th>

                <th class="text-center font-weight-bold" v-if="isQuaterlyRentComputeType">{{ setTextRentTrim() }}</th>

                <th class="text-center font-weight-bold" v-if="showMonthly">{{ setTextRent() }}</th>

                <th id="th_insurance" class="text-center font-weight-bold" v-if="hasServices">
                  {{ $t('simulation.result.table.services') }}
                </th>

                <th v-if="!user.isReadOnly" class="text-center font-weight-bold">
                  {{ $t('simulation.result.table.choice') }}
                </th>

                <th v-if="hasRole('ROLE_RENT_EDIT')"></th>
              </tr>
            </thead>
            <tbody v-if="simulation.finance">
              <tr v-for="(rent, index) in rents" :key="index" :title="rent.title">
                <td :class="selectRentClasses(rent)" e2e-data="simulationRentDuration">
                  {{ rent.duration }} {{ $t('time.month') }}
                </td>
                <td
                  v-if="simulation.finance.initialRent > 0"
                  :class="selectRentClasses(rent)"
                  e2e-data="simulationInitial"
                >
                  {{ $n(Number(setMonthlyRent(simulation.finance.initialRent)), 'currency') }}
                </td>
                <td v-if="isQuaterlyAmountComputeType" :class="selectRentClasses(rent)" e2e-data="simulationRentAmount">
                  {{ $n(Number(setQuaterlyRent(rent.rent, simulation.finance.amount)), 'currency') }}
                </td>
                <td
                  v-if="isQuaterlyRentComputeType"
                  :class="selectRentClasses(rent)"
                  e2e-data="simulationNotMonthlyRentAmount"
                >
                  {{ $n(Number(setQuaterlyRent(rent.rent, simulation.finance.amount)), 'currency') }}
                </td>
                <td v-if="showMonthly" :class="selectRentClasses(rent)" e2e-data="simulationMonthlyRentAmount">
                  {{ $n(Number(setMonthlyRent(rent.monthly)), 'currency') }}
                </td>
                <td v-if="hasServices" :class="selectRentClasses(rent)" e2e-data="simulationServiceRentAmount">
                  {{ $n(Number(setRentWithServices(rent)), 'currency') }}
                </td>

                <td v-if="!user.isReadOnly" class="text-center">
                  <input
                    type="radio"
                    name="duration"
                    :value="rent.duration"
                    :checked="rent.duration === selectedRent.duration"
                    :disabled="rent.disabled"
                    @change="setProfitabilityUp(rent)"
                    e2e-button="selectRent"
                  />
                </td>

                <td class="text-center pt-2" v-if="displayEdit">
                  <button class="btn btn-primary" @click="showCalculator(rent.id)" e2e-button="displayRentModal">
                    <span v-if="rent.hasLevel">{{ $t('level.hasLevel') }}</span>
                    <span v-else><i class="fa fa-lg fa-edit"></i></span>
                  </button>

                  <RentCalculatorModal
                    v-if="simulation.company.computeRentMode"
                    :ref="'modal-rent-calculator' + rent.id"
                    :rent-id="rent.id"
                    :has-service-level="hasServiceLevel"
                    :decision-id="simulation.decision.id"
                    :margin-calculation-method="simulation.company.marginCalculationMethod"
                    @rent-updated="sendRentUp"
                    @set-level="sendLevel"
                  />

                  <AmountCalculatorModal
                    v-if="simulation.company.computeAmountMode"
                    :ref="'modal-amount-calculator' + rent.id"
                    :rent-id="rent.id"
                    :decision-id="simulation.decision.id"
                    @rent-updated="updateSimulation"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <br />

        <div class="row">
          <div class="col-12 fs-16">
            <div id="application_fee_line_ht" v-if="!displayTTC && def.finance.applicationFee.options.display">
              <label class="fs-16">{{ $t('simulation.result.applicationFee') }} :&nbsp;</label>
              <button
                v-if="!def.finance.applicationFee.options.disabled"
                type="button"
                class="btn btn-link"
                e2e-data="simulationApplicationFee"
                @click="showPopupFees"
              >
                {{ $n(Number(simulation.finance.applicationFee), 'currency') }}
              </button>
              <span v-else e2e-data="simulationApplicationFee">{{
                $n(Number(simulation.finance.applicationFee), 'currency')
              }}</span>
              {{ $t('simulation.ht') }} {{ $t('simulation.result.applicationFeeEnd') }}
            </div>

            <div id="application_fee_line_ttc" v-if="displayTTC && def.finance.applicationFee.options.display">
              <label class="fs-16">{{ $t('simulation.result.applicationFee') }} :&nbsp;</label>
              <button
                v-if="!def.finance.applicationFee.options.disabled"
                type="button"
                e2e-data="simulationApplicationFee"
                @click="showPopupFees"
              >
                {{ $n(Number(getTTC(simulation.finance.applicationFee)), 'currency') }}
              </button>
              <span v-else e2e-data="simulationApplicationFee">{{
                $n(Number(getTTC(simulation.finance.applicationFee)), 'currency')
              }}</span>
              {{ $t('simulation.ttc') }} {{ $t('simulation.result.applicationFeeEnd') }}
            </div>

            <div id="court_line_ht" v-if="!displayTTC && simulation.courtRegistryAmount > 0">
              <label class="fs-16">{{ $t('simulation.result.courtFee') }} :&nbsp;</label>
              <span e2e-data="simulationCourtRegistryAmount">{{
                $n(Number(simulation.courtRegistryAmount), 'currency')
              }}</span>
              {{ $t('simulation.ht') }} {{ $t('simulation.result.applicationFeeEnd') }}
            </div>

            <div id="court_line_ttc" v-if="displayTTC && simulation.courtRegistryAmount > 0">
              <label class="fs-16">{{ $t('simulation.result.courtFee') }} :&nbsp;</label>
              <span e2e-data="simulationCourtRegistryAmount">{{
                $n(Number(getTTC(simulation.courtRegistryAmount)), 'currency')
              }}</span>
              {{ $t('simulation.ttc') }} {{ $t('simulation.result.applicationFeeEnd') }}
            </div>
          </div>

          <div class="col-12 fs-16">
            <div id="surrender_value_line_ht" v-if="simulation.residualValue && !displayTTC">
              <label class="fs-16">
                {{ $t('simulation.result.surrender.' + simulation.finance.contractType.id) }} :&nbsp;
              </label>
              <span e2e-data="simulationResidualValue">{{ $n(Number(simulation.residualValue), 'currency') }}</span>
              {{ $t('simulation.ht') }}
            </div>

            <div id="surrender_value_line_ttc" v-if="simulation.residualValue && displayTTC">
              <label class="fs-16">
                {{ $t('simulation.result.surrender.' + simulation.finance.contractType.id) }} :&nbsp;
              </label>
              <span e2e-data="simulationResidualValue">{{
                $n(Number(getTTC(simulation.residualValue)), 'currency')
              }}</span>
              {{ $t('simulation.ttc') }}
            </div>

            <div v-if="simulation.decision.demand && simulation.decision.demand.demandNumber != null">
              <label class="fs-16">{{ $t('simulation.decision.number') }} :&nbsp;</label>
              <span e2e-data="simulationDemandNumber">{{ simulation.decision.demand.demandNumber }}</span>
            </div>

            <div v-if="simulation.decision && simulation.decision.demand">
              <label class="fs-16">{{ $t('simulation.decision.status') }} :&nbsp;</label>
              <span e2e-data="simulationDemandStatus" :class="statusClass(simulation.decision.demand.status)">
                {{ $t('simulation.status.' + simulation.decision.demand.status + '.label') }}
              </span>
            </div>

            <div v-if="simulation.decision.demand && simulation.decision.demand.decisionMessage != null">
              <label class="fs-16">{{ $t('simulation.decision.message') }} :&nbsp;</label>
              <span e2e-data="simulationDemandMessage" v-html="simulation.decision.demand.decisionMessage"></span>
            </div>
          </div>
        </div>
      </BlockContent>
    </div>

    <div class="row">
      <div
        :class="'my-4 py-3 col-11 mx-auto ' + (simulation.refused || isNotAccepted ? 'bg-danger' : 'bg-info')"
        style="border-radius: 1em"
        e2e-block="simulationMessage"
      >
        <div class="text-center" v-html="getMessage()"></div>
        <div v-if="simulation.refused && simulation.commentRefused" class="text-center">
          <b>{{ $t('simulation.fields.commentRefused.label') }} :</b>
          <br />
          {{ simulation.commentRefused }}
        </div>
        <div v-if="simulation.decision && !simulation.decision.isCompatible" class="text-center">
          <table class="table table-striped _table-bordered table-hover fs-16" cellspacing="0">
            <thead>
              <tr>
                <th>{{ $t('simulation.fields.amount.label') }}</th>
                <th>{{ $t('simulation.fields.initialRent.label') }}</th>
                <th>{{ $t('simulation.fields.residualPercent.label') }}</th>
                <th>{{ $t('simulation.fields.duration.label') }}</th>
              </tr>
            </thead>
            <tbody v-if="simulation.decision.demand">
              <tr>
                <td>{{ $n(Number(simulation.decision.demand.finance.amount), 'currency') }}</td>
                <td>{{ $n(Number(simulation.decision.demand.finance.initialRent), 'currency') }}</td>
                <td>{{ simulation.decision.demand.finance.residualPercent }} %</td>
                <td>{{ simulation.decision.demand.finance.duration }} {{ $t('time.month') }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div
          class="text-center"
          v-if="!isCreatable && simulation.refinancerStatus != 'DETAILLED_STUDY' && simulation.status == 'PREACCEPTED'"
        >
          <DocumentList
            ref="documentDec"
            context="Simulation"
            :context-id="simulationId"
            @document-uploaded="afterUpload"
          ></DocumentList>
        </div>
      </div>
      <br />
      <div class="btn-spacer mx-auto" v-if="!user.isReadOnly && !simulation.refused && simulation.status != 'CANCELED'">
        <button
          class="btn btn-primary"
          @click="showPopupProposal"
          v-if="isProposable"
          e2e-button="simulationShowProposal"
        >
          {{ $t('simulation.popin.proposal.button') }}
        </button>
        <ButtonAll
          v-if="displayAccepted"
          margin="no"
          type="validation"
          label="simulation.popin.accepted.button"
          @click="showPopupAccepted"
          e2e-button="simulationShowAccepted"
        />
        <a
          class="btn btn-primary"
          :href="'/contrats/contract.php?i=' + simulation.contractId + '&p=contract'"
          v-if="isCreated"
          e2e-button="simulationShowContract"
        >
          {{ $t('simulation.popin.created.button') }}
        </a>
        <button class="btn btn-primary" @click="goToDemand" v-if="isStudyable" e2e-button="simulationShowStudy">
          {{ $t('simulation.popin.study.button') }}
        </button>
        <button
          class="btn btn-primary"
          @click="createQuotation"
          v-if="simulation.decision && !simulation.decision.isCompatible"
          e2e-button="simulationShowChanged"
        >
          {{ $t('simulation.popin.changed.button') }}
        </button>
        <button
          class="btn btn-primary"
          @click="showPopupDeals"
          v-if="isRequestable && hasRole('ROLE_DEALS')"
          e2e-button="simulationShowDeal"
        >
          <span v-if="!isLoadingDeal">{{ $t('simulation.popin.deal.button') }}</span>
          <div class="text-center" v-else>
            <div class="spinner-border" style="width: 1rem; height: 1rem" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>
        </button>

        <ButtonAll
          v-if="canSendRequest"
          type="validation"
          margin="no"
          label="simulation.popin.request.button"
          :disabled="missingBlockingDocuments.length > 0"
          e2e-button="simulationShowRequest"
          @click="showPopupRequest"
        />

        <button
          class="btn btn-primary"
          @click="goToService"
          v-if="isRequestable && hasRole('ROLE_DETAILLED_STUDY') && !hasRole('ROLE_DEALS') && !user.isReadOnly"
          e2e-button="simulationShowFinalize"
        >
          {{ $t('simulation.popin.finalize.button') }}
        </button>
        <ButtonAll
          v-if="hasContractCreate"
          :disabled="simulation.blockedAt ?? false"
          label="simulation.createContract"
          margin="no"
          type="validation"
          @click="createContract"
          e2e-button="simulationShowCreateContract"
        />
      </div>
    </div>
  </div>

  <SimulationProposalModal
    :simulation="simulation"
    :simulation-id="simulationId"
    :rent="selectedRent"
    :def="def"
    :is-visible="isProposalVisible"
  />

  <SimulationAcceptedModal
    :simulation="simulation"
    :simulation-client-id="simulation.client.id"
    :simulation-id="simulationId"
    :rent="selectedRent"
    :def="def"
    :is-visible="isAcceptedVisible"
  />

  <SimulationExistingDecisionModal
    ref="modalDeals"
    :simulation-id="simulationId"
    @show-pop-up-request="showPopupRequest"
    @loading="isLoading"
  />

  <SimulationNewDemandModal
    :simulation="simulation"
    :simulation-id="simulationId"
    :rent="selectedRent"
    :def="def"
    :is-visible="isRequestVisible"
  />

  <SimulationApplicationFeeModal
    :simulation="simulation"
    :simulation-id="simulationId"
    :def="def"
    :is-visible="isFeesVisible"
  />
  <SimulationRefinancerModal
    v-if="hasModalRefinancer"
    ref="modalRefinancer"
    :rent="selectedRent"
    :simulation="simulation"
  />
  <ServiceFormModal
    v-if="selectedService || selectedServiceType"
    :title="selectedService?.serviceType.label ?? selectedServiceType?.label"
    :service-id="selectedService?.id ?? null"
    :service-type-id="selectedService?.serviceType.id ?? selectedServiceType?.id"
    :finance-id="simulation.finance.id"
    :duration="selectedRent.duration"
    @update="onServiceUpdated"
    @close="hidePopupService"
  />
  <ModalError v-if="errors.length > 0" ref="modalError" id="modal-errors" :errors="errors" />
</template>
